<template>
  <v-app id="inspire">

    <v-content>
      <v-container fluid fill-height v-if="appIsLoaded" ref="main_container">
        <v-layout justify-center align-center>
          <v-flex md12 fill-height>
            <AppMainMenu></AppMainMenu>
            <router-view/>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fill-height v-else>
        <v-layout align-center>
          <v-flex md12 class="text-xs-center">
            <v-progress-circular indeterminate color="primary" :size="100" :width="7">
              <v-icon color="primary">sync</v-icon>
            </v-progress-circular>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>

  </v-app>
</template>

<script>
  import AppMainMenu from '@/components/AppMainMenu'
  import usersAPI from '@/api/user'
  import IsMobile from '@/mixins/IsMobile'

  export default {
    name: 'App',
    components: { AppMainMenu },
    mixins: [ IsMobile ],
    computed: {
      appIsLoaded () {
        return this.$store.getters.appIsLoaded === true || this.$store.getters.logInStatus === false
      }
    },
    mounted () {
      if (this.DetectMobile()) {
        this.$refs.main_container.style.padding = 0
      }
    },
    methods: {
      initData () {
        return new Promise((resolve, reject) => {
          this.$store.dispatch('getProductsCategories')
          if (!this.$can('view', 'vendor')) this.$store.dispatch('getAllUsers')
          if (!this.$can('view', 'vendor')) this.$store.dispatch('getAllClients')
          if (!this.$can('view', 'vendor')) this.$store.dispatch('getAllPlans')
          this.$store.dispatch('getAllProducts')
          this.$store.dispatch('getAllServices')
          this.$store.dispatch('loadAllCases').then(() => {
            resolve()
          })
        })
      }
    },
    beforeCreate () {
      this.$store.dispatch('loadAllCases')
    },
    created () {
      this.initData().then(() => {
        usersAPI.getCurrentUser().then(result => {
          this.$store.dispatch('setCurrentUser', result)
        }, () => {})
      })
      // this.$store.dispatch('clearCaseForms')
    }
  }
</script>

<style lang="stylus">
  @require '../node_modules/vuetify/src/stylus/settings/_colors.styl'
  $theme := {
    primary: #3F51B5
    accent: #FFC107
    secondary: #00BCD4
    info: #B2DFDB
    warning: $red.base
    error: $red.base
    success: $green.base
  }
  @require '../node_modules/vuetify/src/stylus/main.styl'
  .pb9 {
    padding-bottom: 90px
  }
</style>



// WEBPACK FOOTER //
// App.vue?133fcce6